<!-- ARIA Completed -->
<nav class="navbar navbar-expand-lg bg-body shadow">
  <div class="container-lg">
    <button class="navbar-toggler border-0" data-bs-target="#navbarCanvas" data-bs-toggle="offcanvas" type="button" aria-controls="navbarCanvas" aria-label="Menüyü Göster/Gizle" i18n-aria-label>
      <span class="navbar-toggler-icon"></span>
    </button>

    <a class="navbar-brand d-block lh-1 me-lg-3" [routerLink]="['/']" aria-label="Hakikat Ana Sayfa" i18n-aria-label>
      <img class="nav-logo" src="/icons/logo.svg" style="height: 2rem;" alt="">
    </a>

    <div class="offcanvas-lg offcanvas-start flex-grow-1" id="navbarCanvas" aria-labelledby="navbarCanvasLabel">
      <div class="offcanvas-header bg-secondary">
        <h2 id="navbarCanvasLabel" class="visually-hidden" i18n>Menü</h2>
        <img class="mx-auto my-3" src="/icons/logo-white.svg" style="width: 5rem;" alt="Hakikat Logo" i18n-alt>
      </div>
      <div class="offcanvas-body" tabindex="-1" role="dialog" aria-modal="true">
        <ul class="navbar-nav">
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-dismiss="offcanvas" [routerLink]="['/']" type="button" i18n>Ana Sayfa</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-dismiss="offcanvas" [routerLink]="['/']" [fragment]="'about'" type="button" i18n>Hakkımızda</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-dismiss="offcanvas" [routerLink]="['/']" [fragment]="'activities'" type="button" i18n>Faaliyetler</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-dismiss="offcanvas" [routerLink]="['/']" [fragment]="'apply'" type="button" i18n>Başvuru</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-dismiss="offcanvas" [routerLink]="['/']" [fragment]="'team'" type="button" i18n>Takım</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-dismiss="offcanvas" [routerLink]="['/']" [fragment]="'testimonials'" type="button" i18n>Referanslar</button>
          </li>
        </ul>
      </div>
      <div class="offcanvas-footer d-lg-none text-center">
        <a class="icon-link gap-2 link-secondary text-decoration-none" href="tel:+4961057176116" type="phone">
          <fa-icon [icon]="iconPhone" size="sm" aria-hidden="true" />
          <small>+49 6105 - 717 6116</small>
        </a>
        <hr class="my-2" />
        <div class="d-flex align-items-center justify-content-evenly">
          <a class="link-secondary" href="https://www.facebook.com/hakikatev" rel="noopener noreferrer" target="_blank" aria-label="Facebook Sayfası" i18n-aria-label>
            <fa-icon [icon]="iconFacebook" size="lg" aria-hidden="true" />
          </a>
          <a class="link-secondary" href="https://www.instagram.com/hakikatev" rel="noopener noreferrer" target="_blank" aria-label="Instagram Sayfası" i18n-aria-label>
            <fa-icon [icon]="iconInstagram" size="lg" aria-hidden="true" />
          </a>
          <a class="link-secondary" href="https://www.tiktok.com/@hakikatev" rel="noopener noreferrer" target="_blank" aria-label="TikTok Sayfası" i18n-aria-label>
            <fa-icon [icon]="iconTiktok" size="lg" aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>

    <div class="navbar-actions d-flex align-items-center gap-3">
      <app-cart />
    </div>
  </div>
</nav>